import './WelcomeModal.scss'
import { useState, useEffect } from 'react'
import { Modal, ModalSize } from '@att-bit/duc.components.modal'

const WELCOME_KEY = 'acc_portal_welcome_v1_viewed'
const IS_PRODUCTION = window.location.hostname === 'accsupport.att.com'

const updates = [
  {
    label: 'Simplified request categories',
    detail: 'Quickly find the right support option without navigating through unnecessary steps.',
  },
  {
    label: 'Clear guidance for every request',
    detail: 'Each category now includes descriptions, examples, and instructions to help you choose the correct support path.',
  },
  {
    label: 'Faster routing to the right team',
    detail: 'Requests are better aligned to the teams that support them, helping reduce delays and unnecessary transfers.',
  },
  {
    label: 'Improved navigation',
    detail: 'Enhanced labels and organization make it easier to find forms, resources, and support contacts.',
  },
]

const CheckIcon = () => (
  <svg className='welcome-modal-check' width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'>
    <circle cx='9' cy='9' r='9' fill='#0057b8' />
    <path d='M5 9.4L7.6 12L13 6.4' stroke='#fff' strokeWidth='1.6' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
)

export const WelcomeModal = () => {
  const [showWelcome, setShowWelcome] = useState(false)

  useEffect(() => {
    if (!IS_PRODUCTION || !localStorage.getItem(WELCOME_KEY)) {
      setShowWelcome(true)
    }
  }, [])

  const closeModal = () => {
    localStorage.setItem(WELCOME_KEY, 'true')
    setShowWelcome(false)
  }

  return (
    <>
      {showWelcome &&
        <Modal
          onClose={closeModal}
          size={ModalSize.LARGE}
          aria-label={'welcome modal'}
          aria-modal="true"
          scrimZindex={25}
        >
          <Modal.Body>
            <div className='welcome-modal-body'>
              <h2 className='heading-md font-bold mar-b-xxs'>Welcome to the Enhanced ACC Portal</h2>
              <p className='type-sm color-gray-700 mar-b-sm'>We've updated the portal to make getting help easier than ever.</p>
              <div className='welcome-modal-updates'>
                {updates.map(({ label, detail }) => (
                  <div key={label} className='welcome-modal-update-item'>
                    <div className='welcome-modal-update-header'>
                      <CheckIcon />
                      <p className='type-base font-bold'>{label}</p>
                    </div>
                    <p className='type-sm font-regular welcome-modal-update-detail'>{detail}</p>
                  </div>
                ))}
              </div>
              <div className='text-center mar-t-md'>
                <button className='btn-primary' onClick={closeModal}>Continue</button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      }
    </>
  )
}

export default WelcomeModal
